import initDocsResourcesListeners from "@/layouts/resources";
import initNewsletterListeners from "@/layouts/newsletter";
import initContactViewListeners from "@/layouts/contact";
import initGlobalViewListeners from "@/layouts/global";

export const Layouts = {
    init: () => {
        initDocsResourcesListeners();
        initContactViewListeners();
        initGlobalViewListeners();
        initNewsletterListeners();
    },

    initDocsResourcesListeners,
    initContactViewListeners,
    initGlobalViewListeners,
    initNewsletterListeners,
}

export default Layouts;